import { Component, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { IAngularMyDpOptions } from '@nodro7/angular-mydatepicker';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../../app.config';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { DateUtilsService } from '../../../common/date-utils.service';
import { DATEPICKER_CONFIG } from '../../../common/datepicker-config';
import { FixDateService } from '../../../common/fixDate.service';
import { ValidationService } from '../../../common/validation.service';
import { ValueListsService } from '../../../common/value-lists.service';
import { AppConfig } from '../../../models/config/app-config';
import { FormSubGroupControl } from '../../../models/formControls/FormSubGroupControl';
import { ValueListItem } from '../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-ausweispapiere',
  templateUrl: './ausweispapiere.component.html',
  styleUrls: ['./ausweispapiere.component.scss']
})
export class AusweispapiereComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {
  private passaustellenderstaatListItemsSub: Subscription;
  private reisedokumentListItemsSub: Subscription;

  passaustellenderstaatListItems: ValueListItem[];
  reisedokumentListItems: ValueListItem[];


  constructor(fb: FormBuilder,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              @Inject(DATEPICKER_CONFIG) public datepickerOptions: IAngularMyDpOptions,
              fixDateService: FixDateService,
              dateUtils: DateUtilsService,
              assistantPopoverService: AssistantPopoverService,
              @Inject(APP_CONFIG) public appConfig: AppConfig,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      passArt: [null, validationService.getValidators('antragsteller.pass.passArt')],
      passNummer: [null, validationService.getValidators('antragsteller.pass.passnummer')],
      passAusstellungsdatum: [null, validationService.getValidators('antragsteller.pass.gueltigVon', true)],
      passGueltigbis: [null, validationService.getValidators('antragsteller.pass.gueltigBis', true)],
      passAusstellerstaat: [null, validationService.getValidators('antragsteller.pass.ausstellenderStaat')],
      passAusgestelltvon: [null, validationService.getValidators('antragsteller.pass.ausgestelltVon')],
      nationaleIdentNr: [null, validationService.getValidators('antragsteller.nationaleIdentNr')],
      biometrie: new FormSubGroupControl()
    }));

    this.dateFixer = fixDateService.getConverter({ unknownReplacement: '00' });
    this.dateFormatter = dateUtils.getFormatter('yMd');
  }


  ngOnInit() {
    super.ngOnInit();

    this.passaustellenderstaatListItemsSub = this.valueListsService.getValueListItems('passaustellenderstaat')
    .subscribe((listItems: ValueListItem[]) => this.passaustellenderstaatListItems = listItems);

    this.reisedokumentListItemsSub = this.valueListsService.getValueListItems('pass_art')
    .subscribe((listItems: ValueListItem[]) => this.reisedokumentListItems = listItems);
  }

  ngOnDestroy(): void {
    this.passaustellenderstaatListItemsSub.unsubscribe();
    this.reisedokumentListItemsSub.unsubscribe();
  }
}
